export { ButtonText as default } from './ButtonText';